import { Link } from "react-router-dom";

export default function DistributorsForm() {
  return (
    <div className="font-poppins">

      {/* ================= HERO ================= */}
      
       <section className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-center text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm text-[var(--brand-gray)] mb-2">
            <a href="/" className="hover:text-[var(--brand-purple)]">Home</a> ›   Distributors Form
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--brand-dark)]">
             Distributors Form
          </h1>
        </div>
      </section>

      {/* ================= FORM ================= */}
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">

          <h2 className="text-lg font-semibold text-blue-900 mb-8">
            Fill the details
          </h2>

          <form className="space-y-6">

            {/* Name */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>

            {/* Category */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Categories <span className="text-red-500">*</span>
              </label>
              <select className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600">
                <option>Child Care</option>
                <option>FEM Care</option>
                <option>Adult Incontinence</option>
              </select>
            </div>

            {/* Quantity */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Please Enter Quantity in No's
              </label>
              <textarea
                rows="4"
                placeholder="Enter the Quantity in Numbers"
                className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>

            {/* CAPTCHA PLACEHOLDER */}
           

            {/* Submit */}
            <button
              type="submit"
              className="block bg-brandPurple hover:bg-brandPurple text-white px-6 py-2 rounded-md"
            >
              Submit
            </button>

          </form>
        </div>
      </section>

    </div>
  );
}
